<ng-container *ngIf="planForm">
    <div class="form-group">
        <label>1. Tratar Arcos</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" id="pregunta1a" name="pregunta1" value="0"
                    [(ngModel)]="planForm.pregunta1Arcos">
                <label class="form-check-label" for="pregunta1a">Ambos</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta1" value="1" id="pregunta1b"
                    [(ngModel)]="planForm.pregunta1Arcos">
                <label class="form-check-label" for="pregunta1b">Superior</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta1" value="2" id="pregunta1c"
                    [(ngModel)]="planForm.pregunta1Arcos">
                <label class="form-check-label" for="pregunta1c">Inferior</label>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>2. Restricción de movimiento dental</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="checkbox" name="pregunta2RestriccionDental" value="0" id="pregunta2a0"
                    [(ngModel)]="planForm.pregunta2RestriccionDental">
                <label for="pregunta2a0" class="form-check-label">No mover los siguientes dientes</label>
            </div>
            <div class="row">
                <div class="col-10 offset-1">
                    <app-dienteselector [disabled]="!editable" (dientesSelected)="pregunta2DientesSelected($event)" [boca]="boca2">
                    </app-dienteselector>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>3. Attachments o Aditamentos</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="checkbox" name="pregunta3" value="2" id="pregunta3Aditamentos2"
                    [(ngModel)]="planForm.pregunta3Aditamentos" />
                <label class="form-check-label" for="pregunta3Aditamentos2">No colocar aditamentos en los siguientes dientes</label>
            </div>
            <div class="row">
                <div class="col-10 offset-1">
                    <app-dienteselector [disabled]="!editable" (dientesSelected)="pregunta3DientesSelected($event)" [boca]="boca3">
                    </app-dienteselector>
                </div>
            </div>
        </div>
    </div>
    <label>4. Relación Anterior-Posterior (A-P)</label>
    <div class="row">
        <div class="col-10 offset-1">
            <table class="table">
                <tr>
                    <td></td>
                    <td>D</td>
                    <td>I</td>
                </tr>
                <tr>
                    <td><label>Mantener</label></td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4aD" value="1" [(ngModel)]="planForm.pregunta4aMantenerD">
                    </td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4aI" value="2" [(ngModel)]="planForm.pregunta4aMantenerI">
                    </td>
                </tr>
                <tr>
                    <td><label>Mejorar la relación de canino solamente</label></td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4bD" value="1"
                            [(ngModel)]="planForm.pregunta4bMejorarRelacionD"></td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4bI" value="2"
                            [(ngModel)]="planForm.pregunta4bMejorarRelacionI"></td>
                </tr>
                <tr>
                    <td><label>Corrección para clase I</label></td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4cD" value="1"
                            [(ngModel)]="planForm.pregunta4cCorreccionD">
                    </td>
                    <td><input [disabled]="!editable" type="checkbox" name="pregunta4cI" value="2"
                            [(ngModel)]="planForm.pregunta4cCorreccionI">
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="ml-3">
        <div class="form-check">
            <input [disabled]="!editable" class="form-check-input" type="checkbox" name="pregunta4d" value="1"
                [(ngModel)]="planForm.pregunta4dOpcionMovimiento">
            <label class="form-check-label">Opción de movimiento dental (si
                selecciona más de una opción, indicar cantidad y secuencia en observaciones)</label>
        </div>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4daDesgaste"
                    (change)="pregunta4dDesgasteChecked()" id="pregunta4daDesgaste"
                    [(ngModel)]="planForm.pregunta4daDesgaste" value="1">
                <label class="form-check-label" for="pregunta4daDesgaste">Desgaste interproximal
                    posterior</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4dbSimulacion"
                    (change)="pregunta4dDesgasteChecked()" id="pregunta4dbSimulacion"
                    [(ngModel)]="planForm.pregunta4dbSimulacion" value="2">
                <label class="form-check-label" for="pregunta4dbSimulacion">Simulación de corrección de clase II
                    /
                    III</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deCortes"
                    (change)="pregunta4dDesgasteChecked()" id="pregunta4deCortes"
                    [(ngModel)]="planForm.pregunta4deCortes" value="1">
                <label class="form-check-label" for="pregunta4deCortes">Cortes de Presición (Indicar en
                    observaciones el número de diente)</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4dcDistalizacion" value="3"
                    (change)="pregunta4dDesgasteChecked()" id="pregunta4dcDistalizacion"
                    [(ngModel)]="planForm.pregunta4dcDistalizacion">
                <label class="form-check-label" for="pregunta4dcDistalizacion">Distalización diente a
                    diente</label>
            </div>
            <div class="row">
                <div class="col-4 offset-1">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td></td>
                                <td>S</td>
                                <td>I</td>
                                <td></td>
                                <td>V</td>
                                <td>L</td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label">Elástico</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deElasticoS"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deElasticoS"
                                            [(ngModel)]="planForm.pregunta4deElasticoS" value="1">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deElasticoI"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deElasticoI"
                                            [(ngModel)]="planForm.pregunta4deElasticoI" value="2">
                                    </div>

                                </td>
                                <td></td>
                                <td>
                                    <div class="form-check">
                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deElasticoV"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deElasticoV"
                                            [(ngModel)]="planForm.pregunta4deElasticoV" value="1">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">
                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deElasticoL"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deElasticoL"
                                            [(ngModel)]="planForm.pregunta4deElasticoL" value="2">
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label">Botón</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deBotonS"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deBotonS"
                                            [(ngModel)]="planForm.pregunta4deBotonS" value="1">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deBotonI"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deBotonI"
                                            [(ngModel)]="planForm.pregunta4deBotonI" value="2">
                                    </div>
                                </td>
                                <td></td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deBotonV"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deBotonV"
                                            [(ngModel)]="planForm.pregunta4deBotonV" value="1">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">

                                        <input [disabled]="!editable" type="checkbox" class="form-check-input" name="pregunta4deBotonL"
                                            (change)="pregunta4deCortesChecked()" id="pregunta4deBotonL"
                                            [(ngModel)]="planForm.pregunta4deBotonL" value="2">

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
           
            <div class="form-group">
                <label>Observaciones</label>
                <textarea [disabled]="!editable" class="form-control" name="pregunta4dObservacion"
                    [(ngModel)]="planForm.pregunta4dObservacion"></textarea>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>5. Overjet o Resalte Anterior</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="checkbox" name="pregunta5a" id="pregunta5a" value="1"
                    [(ngModel)]="planForm.pregunta5aOverjetMostrar" />
                <label for="pregunta5a" class="form-check-label">Mostrar el overjet después de la
                    alineación</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="checkbox" name="pregunta5b" id="pregunta5b" value="1"
                    [(ngModel)]="planForm.pregunta5bOverjetMejorar" />
                <label for="pregunta5b" class="form-check-label">Mejorar el overjet con desgaste
                    interproximal</label>
            </div>
        </div>
    </div>
    <label>6. Overbite o Sobremordida</label>
    <div class="ml-3">
        <div class="form-check">
            <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta6" id="pregunta6a" value="1"
                (change)="changePregunta6a($event)" [(ngModel)]="planForm.pregunta6" />
            <label for="pregunta6a" class="form-check-label">Mostrar el resultado de
                sobremordida después de la alineación</label>
        </div>
        <div class="form-check">
            <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta6" value="2" id="pregunta6b"
                (change)="changePregunta6b($event)" [(ngModel)]="planForm.pregunta6" />
            <label for="pregunta6b" class="form-check-label">Corregir mordida
                abierta</label>
        </div>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta6Opciones" value="0" id="pregunta6ba"
                    (change)="changePregunta6ba($event)" [(ngModel)]="planForm.pregunta6b" />
                <label for="pregunta6ba" class="form-check-label">Extruir solamente los dientes
                    anteriores</label>
            </div>
            <div class="ml-3">
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6baExtruirSolamenteSup"
                        id="pregunta6baExtruirSolamenteSup" (change)="changePregunta6baOpciones($event)"
                        [(ngModel)]="planForm.pregunta6baExtruirSolamenteSup">
                    <label class="form-check-label" for="pregunta6baExtruirSolamenteSup">Superior</label>
                </div>
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6baExtruirSolamenteInf"
                        id="pregunta6baExtruirSolamenteInf" (change)="changePregunta6baOpciones($event)"
                        [(ngModel)]="planForm.pregunta6baExtruirSolamenteInf">
                    <label class="form-check-label" for="pregunta6baExtruirSolamenteInf">Inferior</label>
                </div>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="radio" name="pregunta6Opciones" id="pregunta6Opciones" class="form-check-input" value="1"
                    (change)="changePregunta6bb($event)" [(ngModel)]="planForm.pregunta6b" />
                <label for="pregunta6Opciones" class="form-check-label">Extruir los dientes anteriores e
                    intruir dientes posteriores</label>
            </div>
            <div class="ml-3">
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6bbExtruireInstruirSup"
                        id="pregunta6bbExtruireInstruirSup" (change)="changePregunta6bbOpciones($event)"
                        [(ngModel)]="planForm.pregunta6bbExtruireInstruirSup">
                    <label class="form-check-label" for="pregunta6bbExtruireInstruirSup">Superior</label>
                </div>
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1"
                        (change)="changePregunta6bbOpciones($event)" name="pregunta6bbExtruireInstruirInf"
                        id="pregunta6bbExtruireInstruirInf" [(ngModel)]="planForm.pregunta6bbExtruireInstruirInf">
                    <label class="form-check-label" for="pregunta6bbExtruireInstruirInf">Inferior</label>
                </div>
            </div>
        </div>
        <div class="form-check">
            <input [disabled]="!editable" type="radio" name="pregunta6" class="form-check-input" value="3" id="pregunta6c"
                (change)="changePregunta6c($event)" [(ngModel)]="planForm.pregunta6" />
            <label class="form-check-label" for="pregunta6c">Corregir la
                mordida profunda</label>
        </div>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta6cOpciones" value="0" id="pregunta6ca"
                    (change)="changePregunta6ca($event)" [(ngModel)]="planForm.pregunta6c" />
                <label class="form-check-label" for="pregunta6ca">
                    Instruir los dientes anteriores solamente</label>
            </div>
            <div class="ml-3">
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6caInstruirSolamenteSup"
                        id="pregunta6caInstruirSolamenteSup" (change)="changePregunta6caOpciones($event)"
                        [(ngModel)]="planForm.pregunta6caInstruirSolamenteSup">
                    <label class="form-check-label" for="pregunta6caInstruirSolamenteSup">Superior</label>
                </div>
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6caInstruirSolamenteInf"
                        id="pregunta6cbInstruirSolamenteInf" (change)="changePregunta6caOpciones($event)"
                        [(ngModel)]="planForm.pregunta6caInstruirSolamenteInf">
                    <label class="form-check-label" for="pregunta6cbInstruirSolamenteInf">Inferior</label>
                </div>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="radio" class="form-check-input" name="pregunta6cOpciones" value="1" id="pregunta6cb"
                    (change)="changePregunta6cb($event)" [(ngModel)]="planForm.pregunta6c" />
                <label class="form-check-label" for="pregunta6cb">Intruir los dientes anteriores y extruir los
                    premolares</label>
            </div>
            <div class="ml-3">
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6cbInstruiryExtruirSup"
                        id="pregunta6cbInstruiryExtruirSup" (change)="changePregunta6cbOpciones($event)"
                        [(ngModel)]="planForm.pregunta6cbInstruiryExtruirSup">
                    <label class="form-check-label" for="pregunta6cbInstruiryExtruirSup">Superior</label>
                </div>
                <div class="form-check">
                    <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta6cbInstruiryExtruirInf"
                        id="pregunta6cbInstruiryExtruirInf" (change)="changePregunta6cbOpciones($event)"
                        [(ngModel)]="planForm.pregunta6cbInstruiryExtruirInf">
                    <label class="form-check-label" for="pregunta6cbInstruiryExtruirInf">Inferior</label>
                </div>
            </div>
        </div>
        <div class="form-check">
            <input [disabled]="!editable" type="radio" name="pregunta6" class="form-check-input" value="4" [(ngModel)]="planForm.pregunta6"
                id="pregunta6d" (change)="changePregunta6d($event)" />
            <label for="pregunta6d" class="form-check-label">Otro</label>
        </div>
        <div class="ml-3">
            <div class="form-group">
                <label>Observaciones</label>
                <textarea [disabled]="!editable" class="form-control" name="pregunta6dOtroObs" (input)="changePregunta6Obs($event)"
                    [(ngModel)]="planForm.pregunta6dOtroObs"></textarea>
            </div>
        </div>
    </div>
    <label>7. Línea media</label>
    <div class="ml-3">
        <div class="form-check">
            <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta7" value="1" [(ngModel)]="planForm.pregunta7"
                id="pregunta7a" (change)="pregunta7aChange($event)" />
            <label class="form-check-label" for="pregunta7a">Mantener la línea media de
                acuerdo con la alineación</label>
        </div>
        <div class="form-check">
            <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta7" value="2" [(ngModel)]="planForm.pregunta7"
                id="pregunta7b" />
            <label class="form-check-label" for="pregunta7b">Modificar la línea media con
                desgaste interproximal</label>
        </div>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" value="1" name="pregunta7bModificarLineaMediaSup"
                    id="pregunta7bModificarLineaMediaSup" (change)="changePregunta7bOpciones($event)"
                    [(ngModel)]="planForm.pregunta7bModificarLineaMediaSup">
                <label class="form-check-label" for="pregunta7bModificarLineaMediaSup">Superior</label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="checkbox" class="form-check-input" value="2" name="pregunta7bModificarLineaMediaInf"
                    id="pregunta7bModificarLineaMediaInf" (change)="changePregunta7bOpciones($event)"
                    [(ngModel)]="planForm.pregunta7bModificarLineaMediaInf">
                <label class="form-check-label" for="pregunta7bModificarLineaMediaInf">Inferior</label>
            </div>
        </div>
        <div class="form-group">
            <label>Observaciones</label>
            <textarea [disabled]="!editable" class="form-control" name="pregunta7bbObservacion"
                [(ngModel)]="planForm.pregunta7bbObservacion"></textarea>
        </div>
    </div>
    <label>8. Manejo de espacios</label>
    <div class="ml-3">
        <label>Diastemas</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" type="radio" class="form-check-input" name="pregunta8" value="1" id="pregunta8a"
                    [(ngModel)]="planForm.pregunta8" />
                <label class="form-check-label" for="pregunta8a"> Cerrar todos los espacios
                </label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="radio" class="form-check-input" name="pregunta8" value="2" id="pregunta8b"
                    [(ngModel)]="planForm.pregunta8" />
                <label class="form-check-label" for="pregunta8b">Dejar espacios específicos
                </label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" type="radio" class="form-check-input" name="pregunta8" value="3" id="pregunta8c"
                    [(ngModel)]="planForm.pregunta8" />
                <label class="form-check-label" for="pregunta8c">Otro</label>
            </div>
            <div class="ml-3">
                <div class="form-group">
                    <label>Observación</label>
                    <textarea [disabled]="!editable" class="form-control" name="pregunta8bOtro" (input)="changePregunta8Obs($event)"
                        [(ngModel)]="planForm.pregunta8bOtro"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>Apiñamiento</label><br>
        <div class="ml-3">
            <label>Corregir Superior</label>
            <div class="row">
                <div class="col-6 offset-3">
                    <table class="table">
                        <tr>
                            <td>Expandir</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8baApinamiento" value="1"
                                        id="pregunta8baApinamiento1"
                                        [(ngModel)]="planForm.pregunta8baApinamiento" /><label
                                        for="pregunta8baApinamiento1" class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8baApinamiento" value="2"
                                        id="pregunta8baApinamiento2"
                                        [(ngModel)]="planForm.pregunta8baApinamiento" /><label
                                        for="pregunta8baApinamiento2" class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8baApinamiento" value="0"
                                        id="pregunta8baApinamiento0"
                                        [(ngModel)]="planForm.pregunta8baApinamiento" /><label class="form-check-label"
                                        for="pregunta8baApinamiento0">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Vestibularizar</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bbVestibularizar"
                                        id="pregunta8bbVestibularizar1" value="1"
                                        [(ngModel)]="planForm.pregunta8bbVestibularizar" /><label
                                        for="pregunta8bbVestibularizar1" class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bbVestibularizar"
                                        id="pregunta8bbVestibularizar2" value="2"
                                        [(ngModel)]="planForm.pregunta8bbVestibularizar" /><label
                                        for="pregunta8bbVestibularizar2" class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bbVestibularizar"
                                        id="pform.pregunta8bbVestibularizar0" value="0"
                                        [(ngModel)]="planForm.pregunta8bbVestibularizar" /><label
                                        for="pform.pregunta8bbVestibularizar0" class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-anterior</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bcDipAnterior" value="1"
                                        id="pregunta8bcDipAnterior1"
                                        [(ngModel)]="planForm.pregunta8bcDipAnterior" /><label
                                        for="pregunta8bcDipAnterior1" class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bcDipAnterior" value="2"
                                        id="pregunta8bcDipAnterior2"
                                        [(ngModel)]="planForm.pregunta8bcDipAnterior" /><label
                                        for="pregunta8bcDipAnterior2" class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bcDipAnterior" value="0"
                                        id="pregunta8bcDipAnterior0"
                                        [(ngModel)]="planForm.pregunta8bcDipAnterior" /><label
                                        for="pregunta8bcDipAnterior0" class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-posterior Der.</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bdDipPosteriorDer" id="pregunta8bdDipPosteriorDer1"
                                        value="1" [(ngModel)]="planForm.pregunta8bdDipPosteriorDer" /><label for="pregunta8bdDipPosteriorDer1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bdDipPosteriorDer" id="pregunta8bdDipPosteriorDer2"
                                        value="2" [(ngModel)]="planForm.pregunta8bdDipPosteriorDer" /><label for="pregunta8bdDipPosteriorDer2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8bdDipPosteriorDer" id="pregunta8bdDipPosteriorDer0"
                                        value="0" [(ngModel)]="planForm.pregunta8bdDipPosteriorDer" /><label for="pregunta8bdDipPosteriorDer0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-posterior Izq.</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8beDipPosteriorIzq" id="pregunta8beDipPosteriorIzq1"
                                        value="1" [(ngModel)]="planForm.pregunta8beDipPosteriorIzq" /><label for="pregunta8beDipPosteriorIzq1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8beDipPosteriorIzq" id="pregunta8beDipPosteriorIzq2"
                                        value="2" [(ngModel)]="planForm.pregunta8beDipPosteriorIzq" /><label for="pregunta8beDipPosteriorIzq2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8beDipPosteriorIzq" id="pregunta8beDipPosteriorIzq0"
                                        value="0" [(ngModel)]="planForm.pregunta8beDipPosteriorIzq" /><label for="pregunta8beDipPosteriorIzq0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <label>Corregir Inferior</label>
            <div class="row">
                <div class="col-6 offset-3">
                    <table class="table">
                        <tr>
                            <td>Expandir</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8caApinamiento" value="1" id="pregunta8caApinamiento1"
                                        [(ngModel)]="planForm.pregunta8caApinamiento" /><label for="pregunta8caApinamiento1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8caApinamiento" value="2" id="pregunta8caApinamiento2"
                                        [(ngModel)]="planForm.pregunta8caApinamiento" /><label for="pregunta8caApinamiento2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8caApinamiento" value="0" id="pregunta8caApinamiento0"
                                        [(ngModel)]="planForm.pregunta8caApinamiento" /><label for="pregunta8caApinamiento0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Vestibularizar</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cbVestibularizar" id="pregunta8cbVestibularizar1"
                                        value="1" [(ngModel)]="planForm.pregunta8cbVestibularizar" /><label for="pregunta8cbVestibularizar1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cbVestibularizar" id="pregunta8cbVestibularizar2"
                                        value="2" [(ngModel)]="planForm.pregunta8cbVestibularizar" /><label for="pregunta8cbVestibularizar2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cbVestibularizar" id="pregunta8cbVestibularizar0"
                                        value="0" [(ngModel)]="planForm.pregunta8cbVestibularizar" /><label for="pregunta8cbVestibularizar0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-anterior</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ccDipAnterior" value="1" id="pregunta8ccDipAnterior1"
                                        [(ngModel)]="planForm.pregunta8ccDipAnterior" /><label for="pregunta8ccDipAnterior1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ccDipAnterior" value="2" id="pregunta8ccDipAnterior2"
                                        [(ngModel)]="planForm.pregunta8ccDipAnterior" /><label for="pregunta8ccDipAnterior2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ccDipAnterior" value="0" id="pregunta8ccDipAnterior0"
                                        [(ngModel)]="planForm.pregunta8ccDipAnterior" /><label for="pregunta8ccDipAnterior0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-posterior Der.</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cdDipPosteriorDer" value="1" id="pregunta8cdDipPosteriorDer1"
                                        [(ngModel)]="planForm.pregunta8cdDipPosteriorDer" /><label for="pregunta8cdDipPosteriorDer1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cdDipPosteriorDer" value="2" id="pform.pregunta8cdDipPosteriorDer2"
                                        [(ngModel)]="planForm.pregunta8cdDipPosteriorDer" /><label for="pform.pregunta8cdDipPosteriorDer2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8cdDipPosteriorDer" value="0" id="pform.pregunta8cdDipPosteriorDer0"
                                        [(ngModel)]="planForm.pregunta8cdDipPosteriorDer" /><label for="pform.pregunta8cdDipPosteriorDer0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>DIP-posterior Izq.</td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ceDipPosteriorIzq" value="1" id="pregunta8ceDipPosteriorIzq1"
                                        [(ngModel)]="planForm.pregunta8ceDipPosteriorIzq" /><label for="pregunta8ceDipPosteriorIzq1"
                                        class="form-check-label">Primero</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ceDipPosteriorIzq" value="2" id="pregunta8ceDipPosteriorIzq2"
                                        [(ngModel)]="planForm.pregunta8ceDipPosteriorIzq" /><label for="pregunta8ceDipPosteriorIzq2"
                                        class="form-check-label">Según lo
                                        necesario</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8ceDipPosteriorIzq" value="0" id="pregunta8ceDipPosteriorIzq0"
                                        [(ngModel)]="planForm.pregunta8ceDipPosteriorIzq" /><label for="pregunta8ceDipPosteriorIzq0"
                                        class="form-check-label">Ninguno</label>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>Extracciones</label>
        <div class="ml-3">
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8dExtraccion" value="0" id="pregunta8dExtraccion0"
                    [(ngModel)]="planForm.pregunta8dExtraccion" />
                <label class="form-check-label" for="pregunta8dExtraccion0">
                    Ninguna
                </label>
            </div>
            <div class="form-check">
                <input [disabled]="!editable" class="form-check-input" type="radio" name="pregunta8dExtraccion" value="1" id="pregunta8dExtraccion1"
                    [(ngModel)]="planForm.pregunta8dExtraccion" />
                <label class="form-check-label" for="pregunta8dExtraccion1">
                    Extracción de estos dientes
                </label>
            </div>
            <div class="row">
                <div class="col-10 offset-1">
                    <app-dienteselector [disabled]="!editable" (dientesSelected)="extraccionDientesSelected($event)" [boca]="boca8">
                    </app-dienteselector>
                </div>
            </div>
        </div>
    </div>
    <label>9. Instrucciones Adicionales</label>
    <div class="form-group">
        <textarea [disabled]="!editable" class="form-control" name="pregunta9ObservacionesComplementarias"
            [(ngModel)]="planForm.pregunta9ObservacionesComplementarias"></textarea>
    </div>
    <div class="form-group">
        <label>Radiografía Lateral</label>
        <div *ngIf="urlRadiografiaLateral"><img [src]="urlRadiografiaLateral" height="200"></div>
        <div *ngIf="!urlRadiografiaLateral && archivoExiste('rad-lateral')"><img [src]="getFileUrl('rad-lateral', 'jpg')"
                height="200"></div>
        <input *ngIf="editable" type="file" accept=".jpg, .jpeg, .png" #fileuploadRadLat [(ngModel)]="radLateral" name="radLateral"
            (change)="seleccionarRadiografiaLateral($event)" class="form-control" />
    </div>
    <div class="form-group">
        <label>Radiografía Panorámica</label>
        <div *ngIf="urlRadiografiaPanoramica"><img [src]="urlRadiografiaPanoramica" height="200"></div>
        <div *ngIf="!urlRadiografiaPanoramica && archivoExiste('rad-panoramica')"><img [src]="getFileUrl('rad-panoramica', 'jpg')"
                height="200"></div>
        <input *ngIf="editable"  type="file" accept=".jpg, .jpeg, .png" #fileuploadRadPan [(ngModel)]="radPan" name="radPan"
            (change)="seleccionarRadiografiaPan($event)" class="form-control" />
    </div>
    <div class="form-group">
        <label>Archivos STL</label>
        <div class="row">
            <div class="col-4">
                <div *ngIf="urlStl1"><img [src]="urlStl1" height="200"></div>
                <div *ngIf="archivoExiste('stl-1')">
                    <a [href]="getFileUrl('stl-1', 'stl')" target="_blank">Ver archivo</a>
                </div>
                <input *ngIf="editable" type="file" accept=".stl" #fileuploadStl1 [(ngModel)]="stl1" name="stl1" accept=".stl"
                    (change)="seleccionarSTL1($event)" class="form-control" />
            </div>
            <div class="col-4">
                <div *ngIf="urlStl2"><img [src]="urlStl2" height="200"></div>
                <div *ngIf="archivoExiste('stl-2')">
                    <a [href]="getFileUrl('stl-2', 'stl')" target="_blank">Ver archivo</a>
                </div>
                <input *ngIf="editable" type="file" accept=".stl" #fileuploadStl2 [(ngModel)]="stl2" name="stl2" accept=".stl"
                    (change)="seleccionarSTL2($event)" class="form-control" />
            </div>
            <div class="col-4">
                <div *ngIf="urlStl3"><img [src]="urlStl3" height="200"></div>
                <div *ngIf="archivoExiste('stl-3')">
                    <a [href]="getFileUrl('stl-3', 'stl')" target="_blank">Ver archivo</a>
                </div>
                <input *ngIf="editable" type="file" accept=".stl" #fileuploadStl3 [(ngModel)]="stl3" name="stl3" accept=".stl"
                    (change)="seleccionarSTL3($event)" class="form-control" />
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div *ngIf="urlStl4"><img [src]="urlStl4" height="200"></div>
                <div *ngIf="archivoExiste('stl-4')">
                    <a [href]="getFileUrl('stl-4', 'stl')" target="_blank">Ver archivo</a>
                </div>
                <input *ngIf="editable" type="file" accept=".stl" #fileuploadStl4 [(ngModel)]="stl4" name="stl4" accept=".stl"
                    (change)="seleccionarSTL4($event)" class="form-control" />
            </div>
            <div class="col-4">
                <div *ngIf="urlStl5"><img [src]="urlStl5" height="200"></div>
                <div *ngIf="archivoExiste('stl-5')">
                    <a [href]="getFileUrl('stl-5', 'stl')" target="_blank">Ver archivo</a>
                </div>
                <input *ngIf="editable" type="file" accept=".stl" #fileuploadStl5 [(ngModel)]="stl5" name="stl5" accept=".stl"
                    (change)="seleccionarSTL5($event)" class="form-control" />
            </div>
        </div>
    </div>
</ng-container>